/**
 * Management Cookies and Timeout Promise
 */
export const setCookie = function (cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 60 * 60 * 1000))
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export const getCookie = function (name) {
  const match = document.cookie.match(new RegExp(name + '=([^;]+)'))
  if (match) {
    return match[1]
  }
  return null
}

export const timeoutPromise = function (milis, data) {
  console.log('Waiting....')
  return new Promise(function (resolve, reject) {
    setTimeout(function() {
      console.log('Waiting Finish..')
      resolve(data)
    }, milis)
  })
}
